<template>
  <div class="quiz-player-block">
    <div class="finish-screen">
      <div
        v-if="loggedIn"
        class="finish-img"
      >
        {{ take.score }}
      </div>
      <div
        v-if="loggedIn"
        class="message-finish"
      >
        Well Done! You understand this {{ targetDescription }}.
        <br> You’ve earned {{ take.score }} SOPHIA points.
      </div>
      <div v-else>
        <div class="success-checkmark-block">
          <i class="far fa-check" />
        </div>
      </div>
      <div class="buttons">
        <a
          v-if="!loggedIn"
          :href="signUpPath"
          class="f-button blue wide ga-quiz-click-signup"
        >
          Sign Up
        </a>
        <a
          v-if="nextUrl"
          :href="nextUrl"
          class="f-button blue wide"
        >
          Go To The Next Concept
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "QuizFinish",
  computed: {
    ...mapGetters(["take"]),
    targetDescription() {
      return this.target.type == "Outline" ? "concept" : "tutorial";
    },
    signUpPath() {
      return SOPHIA.Routes.new_user_path({
        redirect: window.location.toString()
      });
    }
  },
  props: {
    loggedIn: Boolean,
    target: Object,
    nextUrl: String
  },
  mounted() {
    if (!this.loggedIn) {
      SOPHIA.gaEvent.trackEventById("quiz_signup");
    }
  }
};
</script>
